import {
  BoundOrdering,
  LogicalOperatorEnumerator,
  LogicalOperatorTypes,
} from "../Elements/FilterSelect/LogicalOperatorsOptions";

/**
 * Prepares and return the druid filter for Equals (numbers)
 * @param {*} filter
 * @param {*} lo
 */
const setEquals = (filter, lo) => ({
  type: LogicalOperatorTypes.selector,
  dimension: filter.dimension,
  value: lo.value.value,
});

/**
 * Prepares and returnd the druid filter for IsBetween (numbers)
 * @param {*} filter
 * @param {*} lo
 */
const setIsBetween = (filter, lo) => ({
  type: LogicalOperatorTypes.bound,
  dimension: filter.dimension,
  upperStrict: true,
  upper: lo.value.valueB,
  lowerStrict: true,
  lower: lo.value.valueA,
  ordering: BoundOrdering.numeric,
});

/**
 * Prepares and returns the Druid filter for Less than (numbers)
 * @param {*} filter
 * @param {*} lo
 */
const setLessThan = (filter, lo) => ({
  type: LogicalOperatorTypes.bound,
  dimension: filter.dimension,
  upper: lo.value.value,
  ordering: BoundOrdering.numeric,
  upperStrict: true,
});

/**
 *
 * @param {*} filter
 * @param {*} lo
 */
const setGreaterThan = (filter, lo) => ({
  type: LogicalOperatorTypes.bound,
  dimension: filter.dimension,
  lower: lo.value.value,
  ordering: BoundOrdering.numeric,
  lowerStrict: true,
});

const loMapFuncSet = {
  [LogicalOperatorEnumerator.Equals]: setEquals,
  [LogicalOperatorEnumerator.DoesNotEqual]: setEquals,
  [LogicalOperatorEnumerator.IsBetween]: setIsBetween,
  [LogicalOperatorEnumerator.IsNotBetween]: setIsBetween,
  [LogicalOperatorEnumerator.LessThan]: setLessThan,
  [LogicalOperatorEnumerator.GreaterThan]: setGreaterThan,
};

/**
 * Calculate the filter according the logical operator for Numbers and returns the filter for Druid
 */
const QueryFilterNumbers = (filterProps, logicalOperator) => {
  return loMapFuncSet[logicalOperator.description](
    filterProps,
    logicalOperator
  );
};
export default QueryFilterNumbers;
